export function FireReasonDescription(data) {
    const { id, text: description, link, dissmissFiles: files } = data;

    return {
        id,
        description: description || "",
        link: link || "",
        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        hasDescription: description || link || (files && files.length),
    };
}

export function FireReason(data) {
    const { id, description: name } = data;

    return {
        id,
        name: name || "",

        ...FireReasonDescription(data),
    };
}

export function formatFireReason(data) {
    const { id, name, description, link, files, oldFiles } = data;

    const params = {
        description: name,
        files,
        oldFiles,
        text: description,
        link,
    };

    if (id) params.id = id;

    return params;
}
